<template>
    <div class="ls-input-label">
        <div class="ls-input-label--top">
            <div class="ls-input-label--labels">
                <p test-id="label" :class="['ls-input-label--label', { error: error }]">
                    {{ label }}
                </p>
                <p test-id="sub_label" class="ls-input-label--sub-label">{{ subLabel }}</p>
            </div>
            <div
                v-if="collapseContent"
                test-id="question_mark"
                class="ls-input-label--question-mark"
                @click="onClick"
            >
                ?
            </div>
        </div>
        <BCollapse v-if="collapseContent" :open.sync="open" test-id="collapse">
            <div class="ls-input-label--collapse-content">{{ collapseContent }}</div>
        </BCollapse>
    </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'LsInputLabel',
    props: {
        label: VueTypes.string,
        subLabel: VueTypes.string,
        error: VueTypes.bool.def(false),
        collapseContent: VueTypes.string,
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        onClick() {
            this.open = !this.open;
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-input-label {
    padding: 5px 0;
}

.ls-input-label--label {
    color: $secondary;

    &.error {
        color: $danger;
    }
}

.ls-input-label--top {
    display: flex;
    justify-content: space-between;
}
.ls-input-label--question-mark {
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    color: $white;
    font-weight: bold;
    font-size: $size-6;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: $blue;
    margin-left: 10px;
}

.ls-input-label--collapse-content {
    margin-top: 6px;
    font-size: $size-6;
    font-style: italic;
    background-color: $primary-light;
    padding: 20px;
}
</style>
